const Positions = [{ id: null, name: '' }].concat(
  Array.from(Array(10), (_, i) => { i = i + 1; return { id: i, name: `${i}` }; } ));

export default Positions;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/StaticData/Positions.tsx